import React from 'react';
import PropTypes from 'prop-types';

export default function Appearance({ appearance }) {
    const {
        institute_name,
        subtitle,
        year
    } = appearance;

    return (
        <li>
            <p>{institute_name}</p>
            <p>{subtitle} {year}</p>
        </li>
    );
}

Appearance.propTypes = {
    appearance: PropTypes.shape({
        institute_name: PropTypes.string,
        subtitle: PropTypes.string,
        year: PropTypes.string
    })
};

Appearance.defaultProps = {
    appearance: {}
};
